import { lazy } from "react";
import { connect } from "react-redux";
import { loading } from "../../../../store/administration/selectors/requirements";

const NewRequirement = lazy(() => import("./NewRequirement"));

const mapStateToProps = (state) => ({
  loading: loading(state),
});

export default connect(mapStateToProps)(NewRequirement);
